// src/config/googleConfig.js

// Google OAuth configuration
export const googleConfig = {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your-google-client-id-here',
    redirectUri: process.env.REACT_APP_GOOGLE_REDIRECT_URI || `${window.location.origin}/google-callback`,
    scope: 'openid profile email',
    responseType: 'code',
    accessType: 'offline',
    prompt: 'consent'
};

// Google OAuth scopes
export const googleScopes = [
    'openid',
    'profile',
    'email'
];

// Google API endpoints
export const googleApiConfig = {
    userInfoEndpoint: 'https://www.googleapis.com/oauth2/v2/userinfo',
    tokenEndpoint: 'https://oauth2.googleapis.com/token',
    authEndpoint: 'https://accounts.google.com/o/oauth2/v2/auth'
};